import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _01_PLANT_FIBRES:Partial<EcosystemServiceModel> ={
  id:'plant-fibres',
  pos:1,
  image: "/images/ecoservices/plant_fibres.jpg",
  code: ["1.1.5.2", "1.1.1.2"],
  unit:'plant fibres',
  assetType:'other',
  serviceType: 'provisioning',
  valuationMethods:[
    {
      id: 'market',
      name:"Market prices",
      unit: "kg",
      element: "plant fibres",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]


}
